import styled from '@shazambanking/sdk/styles/emotion';
import { ThemeState } from '@shazambanking/sdk/types/state';

export const NewAccountFormWrapper = styled('div')(({ theme }: { theme: ThemeState }) => ({
  // tslint:disable: object-literal-sort-keys
  '.new-account-panel': {
    backgroundColor: theme.palette.common.white,
    backgroundImage: 'none',
    borderColor: 'rgb(197, 196, 196)',
    borderImage: 'initial',
    borderRadius: '5px',
    borderStyle: 'solid',
    borderWidth: '1px',
    boxShadow: 'none',
    color: 'rgb(51, 51, 51)',
    marginBottom: '20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '50%',
    padding: '20px'
  },
  '.main-header': {
    backgroundColor: theme.palette.common.white,
    borderBottom: '1px solid rgb(213, 213, 213)',
    color: theme.palette.common.black,
    display: 'flex',
    flex: '0 0 auto',
    flexWrap: 'wrap',
    '.logo': {
      alignItems: 'center',
      boxSizing: 'inherit',
      display: 'flex',
      flex: '1 1 0%',
      height: '6.25rem',
      justifyContent: 'flex-start',
      marginLeft: '20%',
      paddingLeft: '20px',
    },
    overflowX: 'hidden',
    position: 'sticky',
    top: '0px',
    width: '100%',
    zIndex: 1000
  },
  '.spacer': {
    height: '30px'
  },
}));
